var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, max-len, no-var, one-var, react/jsx-closing-bracket-location, react/sort-comp, space-before-function-paren */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var ReactDOM = require("react-dom");
var _ = require("underscore");

var BlurInput = require("react-components/blur-input.jsx");
var InfoTip = require("../components/info-tip.jsx");
var NumberInput = require("../components/number-input.jsx");
var RangeInput = require("../components/range-input.jsx");
var SvgImage = require("../components/svg-image.jsx");
var TextListEditor = require("../components/text-list-editor.jsx");

var Plotter = require("./plotter.jsx").widget;

var knumber = require("kmath").number;

var BAR = "bar",
    LINE = "line",
    PIC = "pic",
    HISTOGRAM = "histogram",
    DOTPLOT = "dotplot";

// Return a copy of array with length n, padded with given value
function padArray(array, n, value) {
    var copy = _.clone(array);
    copy.length = n;
    for (var i = array.length; i < n; i++) {
        copy[i] = value;
    }
    return copy;
}

var editorDefaults = {
    scaleY: 1,
    maxY: 10,
    snapsPerLine: 2
};

var widgetPropTypes = {
    type: React.PropTypes.oneOf([BAR, LINE, PIC, HISTOGRAM, DOTPLOT]),
    labels: React.PropTypes.arrayOf(React.PropTypes.string),
    categories: React.PropTypes.arrayOf(React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string])),

    scaleY: React.PropTypes.number,
    maxY: React.PropTypes.number,
    snapsPerLine: React.PropTypes.number,

    picSize: React.PropTypes.number,
    pixBoxHeight: React.PropTypes.number,
    picUrl: React.PropTypes.string,

    plotDimensions: React.PropTypes.arrayOf(React.PropTypes.number),
    labelInterval: React.PropTypes.number,
    starting: React.PropTypes.arrayOf(React.PropTypes.number),
    correct: React.PropTypes.arrayOf(React.PropTypes.number),
    static: React.PropTypes.bool,
    onChange: React.PropTypes.func
};

var formatNumber = function formatNumber(num) {
    return "$" + knumber.round(num, 2) + "$";
};

var PlotterEditor = React.createClass({
    displayName: "PlotterEditor",

    propTypes: widgetPropTypes,

    getDefaultProps: function getDefaultProps() {
        return _.extend({}, editorDefaults, {
            correct: [1],
            starting: [1],

            type: BAR,
            labels: ["", ""],
            categories: [""],

            picSize: 30,
            picBoxHeight: 36,
            picUrl: Khan.imageBase + "badges/earth-small.png",

            plotDimensions: [275, 200],
            labelInterval: 1
        });
    },

    getInitialState: function getInitialState() {
        return {
            editing: "correct",
            pic: null,
            loadedUrl: null,
            minX: null,
            maxX: null,
            tickStep: null
        };
    },

    componentWillMount: function componentWillMount() {
        this.fetchPic(this.props.picUrl);
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        this.fetchPic(nextProps.picUrl);
    },

    fetchPic: function fetchPic(url) {
        var _this = this;

        if (this.state.loadedUrl !== url) {
            var pic = new Image();
            pic.src = url;
            pic.onload = function () {
                _this.setState({
                    pic: pic,
                    loadedUrl: url
                });
            };
        }
    },

    render: function render() {
        var setFromScale = _.contains([LINE, HISTOGRAM, DOTPLOT], this.props.type);
        var canChangeSnaps = !_.contains([PIC, DOTPLOT], this.props.type);
        var props = _extends({
            trackInteraction: function trackInteraction() {}
        }, this.props);

        return React.createElement(
            "div",
            { className: "perseus-widget-plotter-editor" },
            React.createElement(
                "div",
                null,
                "Chart type:",
                " ",
                _.map([BAR, LINE, PIC, HISTOGRAM, DOTPLOT], function (type) {
                    return React.createElement(
                        "label",
                        { key: type },
                        React.createElement("input", {
                            type: "radio",
                            name: "chart-type",
                            checked: this.props.type === type,
                            onChange: _.partial(this.changeType, type)
                        }),
                        type
                    );
                }, this)
            ),
            React.createElement(
                "div",
                null,
                "Labels:",
                " ",
                _.map(["x", "y"], function (axis, i) {
                    return React.createElement(
                        "label",
                        { key: axis },
                        axis + ":",
                        React.createElement("input", {
                            type: "text",
                            onChange: _.partial(this.changeLabel, i),
                            defaultValue: this.props.labels[i]
                        })
                    );
                }, this)
            ),
            setFromScale && React.createElement(
                "div",
                { className: "set-from-scale-box" },
                React.createElement(
                    "span",
                    { className: "categories-title" },
                    "Set Categories From Scale"
                ),
                React.createElement(
                    "div",
                    null,
                    React.createElement(
                        "label",
                        null,
                        "Tick Step:",
                        " ",
                        React.createElement(NumberInput, {
                            placeholder: 1,
                            useArrowKeys: true,
                            value: this.state.tickStep,
                            onChange: this.handleChangeTickStep
                        })
                    ),
                    React.createElement(
                        InfoTip,
                        null,
                        React.createElement(
                            "p",
                            null,
                            "The difference between adjacent ticks."
                        )
                    )
                ),
                React.createElement(
                    "div",
                    null,
                    React.createElement(
                        "label",
                        null,
                        "Range:",
                        " ",
                        React.createElement(RangeInput, {
                            placeholder: [0, 10],
                            useArrowKeys: true,
                            value: [this.state.minX, this.state.maxX],
                            onChange: this.handleChangeRange
                        })
                    )
                ),
                React.createElement(
                    "div",
                    null,
                    React.createElement(
                        "button",
                        { onClick: this.setCategoriesFromScale },
                        "Set Categories",
                        " "
                    )
                )
            ),
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    "Label Interval:",
                    " ",
                    React.createElement(NumberInput, {
                        useArrowKeys: true,
                        value: this.props.labelInterval,
                        onChange: this.changeLabelInterval
                    })
                ),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "Which ticks to display the labels for. For instance, setting this to \"4\" will only show every 4th label (plus the last one)"
                    )
                )
            ),
            this.props.type === PIC && React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    "Picture:",
                    " ",
                    React.createElement(BlurInput, {
                        className: "pic-url",
                        value: this.props.picUrl,
                        onChange: this.changePicUrl
                    }),
                    React.createElement(
                        InfoTip,
                        null,
                        React.createElement(
                            "p",
                            null,
                            "Use the default picture of Earth, or insert the URL for a different picture using the \"Add image\" function."
                        )
                    )
                ),
                this.state.pic && this.state.pic.width !== this.state.pic.height && React.createElement(
                    "p",
                    { className: "warning" },
                    React.createElement(
                        "b",
                        null,
                        "Warning"
                    ),
                    ": You are using a picture which is not square. This means the image will get distorted. You should probably crop it to be square."
                )
            ),
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    "Categories:",
                    " ",
                    React.createElement(TextListEditor, {
                        ref: "categories",
                        layout: "horizontal",
                        options: this.props.categories,
                        onChange: this.changeCategories
                    })
                )
            ),
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    "Scale (y):",
                    " ",
                    React.createElement("input", {
                        type: "text",
                        onChange: this.changeScale,
                        defaultValue: this.props.scaleY
                    })
                )
            ),
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    "Max y:",
                    " ",
                    React.createElement("input", {
                        type: "text",
                        ref: "maxY",
                        onChange: this.changeMax,
                        defaultValue: this.props.maxY
                    })
                )
            ),
            canChangeSnaps && React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    "Snaps per line:",
                    " ",
                    React.createElement("input", {
                        type: "text",
                        onChange: this.changeSnaps,
                        defaultValue: this.props.snapsPerLine
                    })
                ),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "Creates the specified number of divisions between the horizontal lines. Fewer snaps between lines makes the graph easier for the student to create correctly."
                    )
                )
            ),
            React.createElement(
                "div",
                null,
                "Editing values:",
                " ",
                _.map(["correct", "starting"], function (editing) {
                    return React.createElement(
                        "label",
                        { key: editing },
                        React.createElement("input", {
                            type: "radio",
                            name: "editing",
                            checked: this.state.editing === editing,
                            onChange: _.partial(this.changeEditing, editing)
                        }),
                        editing
                    );
                }, this),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "Use this toggle to switch between editing the correct answer (what the student will be graded on) and the starting values (what the student will see plotted when they start the problem). Note: These cannot be the same."
                    ),
                    React.createElement(
                        "p",
                        null,
                        "In static mode, the starting values are rendered out to the displayed widget."
                    )
                )
            ),
            React.createElement(Plotter, _extends({}, props, {
                starting: this.props[this.state.editing],
                onChange: this.handlePlotterChange
            }))
        );
    },

    handleChangeTickStep: function handleChangeTickStep(value) {
        this.setState({
            tickStep: value
        });
    },

    handleChangeRange: function handleChangeRange(newValue) {
        this.setState({
            minX: newValue[0],
            maxX: newValue[1]
        });
    },

    changeLabelInterval: function changeLabelInterval(value) {
        this.props.onChange({
            labelInterval: value
        });
    },

    handlePlotterChange: function handlePlotterChange(newProps) {
        var props = {};
        props[this.state.editing] = newProps.values;
        this.props.onChange(props);
    },

    changeType: function changeType(type) {
        var categories;
        if (type === HISTOGRAM) {
            // Switching to histogram, add a label (0) to the left
            categories = [formatNumber(0)].concat(this.props.categories);
            this.props.onChange({ type: type, categories: categories });
        } else if (this.props.type === HISTOGRAM) {
            // Switching from histogram, remove a label from the left
            categories = this.props.categories.slice(1);
            this.props.onChange({ type: type, categories: categories });
        } else {
            this.props.onChange({ type: type });
        }

        if (categories) {
            ReactDOM.findDOMNode(this.refs.categories).value = categories.join(", ");
        }
    },

    changeLabel: function changeLabel(i, e) {
        var labels = _.clone(this.props.labels);
        labels[i] = e.target.value;
        this.props.onChange({ labels: labels });
    },

    changePicUrl: function changePicUrl(value) {
        // We don't need the labels and other data in the plotter, so just
        // extract the raw image and use that.
        // TODO(emily): Maybe indicate that such a change has happened?
        var url = SvgImage.getRealImageUrl(value);

        this.props.onChange({ picUrl: url });
    },

    changeCategories: function changeCategories(categories) {
        var n = categories.length;
        if (this.props.type === HISTOGRAM) {
            // Histograms with n labels/categories have n - 1 buckets
            n--;
        }
        var value = this.props.scaleY;

        this.props.onChange({
            categories: categories,
            correct: padArray(this.props.correct, n, value),
            starting: padArray(this.props.starting, n, value)
        });
    },

    changeScale: function changeScale(e) {
        var oldScale = this.props.scaleY;
        var newScale = +e.target.value || editorDefaults.scaleY;

        var scale = function scale(value) {
            return value * newScale / oldScale;
        };

        var maxY = scale(this.props.maxY);

        this.props.onChange({
            scaleY: newScale,
            maxY: maxY,
            correct: _.map(this.props.correct, scale),
            starting: _.map(this.props.starting, scale)
        });

        ReactDOM.findDOMNode(this.refs.maxY).value = maxY;
    },

    changeMax: function changeMax(e) {
        this.props.onChange({
            maxY: +e.target.value || editorDefaults.maxY
        });
    },

    changeSnaps: function changeSnaps(e) {
        this.props.onChange({
            snapsPerLine: +e.target.value || editorDefaults.snapsPerLine
        });
    },

    changeEditing: function changeEditing(editing) {
        this.setState({ editing: editing });
    },

    setCategoriesFromScale: function setCategoriesFromScale() {
        var scale = this.state.tickStep || 1;
        var min = this.state.minX || 0;
        var max = this.state.maxX || 0;
        var length = Math.floor((max - min) / scale) * scale;

        var categories;
        if (this.props.type === HISTOGRAM || this.props.type === DOTPLOT) {
            // Ranges for histogram and dotplot labels should start at zero
            categories = _.range(0, length + scale, scale);
        } else {
            categories = _.range(scale, length + scale, scale);
        }

        categories = _.map(categories, function (num) {
            return num + min;
        });
        categories = _.map(categories, formatNumber);

        this.changeCategories(categories);

        ReactDOM.findDOMNode(this.refs.categories).value = categories.join(", ");
    },

    serialize: function serialize() {
        var json = _.pick(this.props, "correct", "starting", "type", "labels", "categories", "scaleY", "maxY", "snapsPerLine", "labelInterval");

        if (this.props.type === PIC) {
            json.picUrl = this.props.picUrl;
        }

        return json;
    }
});

module.exports = PlotterEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/plotter-editor.jsx
 ** module id = 141
 ** module chunks = 0 1
 **/